
import React from 'react';
import { connect } from 'react-redux';
import ClipItem from 'components/Clip/ClipItem/ClipItem';
import * as ConfigTypes from 'config/ConfigTypes';

import { Flow } from 'flow-react';
import { observer } from 'mobx-react';

import * as actions from 'store/actions';

import './ClipList.scss';

const ClipList = observer(
    class ClipList extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                cliplist: []
            }
        }

        updateClipList = () => {
            const { cliplist } = this.props.mediaObjects;
            // if (cliplist && cliplist.length) {
            if (cliplist) {
                this.setState({ cliplist: cliplist });
            }
        }

        showClipList = (item, i) => {
            if (this.props.mediaObjects.viewMode == ConfigTypes.LIST) {
                return (<ClipItem key={`cliplistCard_${i}`} clip={item} />)
            }
            return (<ClipItem key={`cliplistCard_${i}`} clip={item} />)
        }

        showList = () => {
            if (this.props.mediaObjects.viewMode == ConfigTypes.LIST) {
                return (
                    <div className="list-group">
                        {this.state.cliplist.map((item, i) => this.showClipList(item, i))}
                    </div>
                )
            }
            return (
                <div className="row cliplist-grid">
                    {this.state.cliplist.map((item, i) => this.showClipList(item, i))}
                </div>
            )
        }

        componentDidUpdate(prev) {
            if (prev.mediaObjects.cliplist != this.props.mediaObjects.cliplist) {
                this.updateClipList();
            }
        }

        componentDidMount() {
            this.updateClipList();
        }

        render() {
            return (
                // <div className="cliplist col-10 mx-auto p-0">
                <div className="cliplist p-0">
                    {this.showList()}
                </div>
            )
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    updateAppObjects: (obj) => dispatch(actions.updateAppObjects(obj)),
})

export default Flow.injectFlow(connect(mapStateToProps, mapDispatchToProps)(ClipList));